import React, { useState } from "react";
import "./stylesheet/style.css";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import CinemaHallDraw from "./CinemaHallDraw";
import useExerciseManager from "./hooks/useExerciseManager";
import CinemaHallButtons from "./CinemaHallButtons";
import SelectTickets from "./SelectTickets";
import useBasketManager from "./hooks/useBasketManager";

const CinemaHall: React.FC = () => {
  const isDesktop = useDesktopSize();
  const { exerciseName, exerciseDate, exercise } = useExerciseManager();
  const [activeStep, setActiveStep] = useState(0);
  const { addAssortToBasket, basket, total, validateBasket } = useBasketManager();

  return (
    <div className={isDesktop ? "cinema-hall-wrapper" : "cinema-hall-wrapper-mobile"}>
      <div className={"cinema-hall-header"}>
        <div>
          <p>Kino Galeria Rzeszów</p>
          <p>Sala 1</p>
          <p>{exerciseDate}</p>
        </div>
        <div>
          <h3>{exerciseName}</h3>
        </div>
      </div>
      <div className={"cinema-hall-seats"}>
        {activeStep === 1 ? (
          <SelectTickets exercise={exercise} basket={basket} addAssortToBasket={addAssortToBasket} />
        ) : (
          <CinemaHallDraw exercise={exercise} />
        )}
      </div>
      <CinemaHallButtons
        activeStep={activeStep}
        setActiveStep={setActiveStep}
        totalBasket={total}
        validateBasket={validateBasket}
      />
    </div>
  );
};

export default CinemaHall;
